// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__20Nsc","errorLogs":"styles_errorLogs__2Mn0l"};